/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./filter.vue?vue&type=template&id=2b5cb718"
import script from "./filter.vue?vue&type=script&lang=js"
export * from "./filter.vue?vue&type=script&lang=js"
import style0 from "./filter.vue?vue&type=style&index=0&id=2b5cb718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports